var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShopingFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 20.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 20.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 3.5a.5.5 0 0 0 0 1h2.33c.2 0 .38.12.46.31L8.54 15.2a.5.5 0 0 0 .46.31h8.34c.6 0 1.14-.36 1.38-.9l2.14-5a1.5 1.5 0 0 0-1.38-2.1h-13L5.21 4.43a1.5 1.5 0 0 0-1.4-.93H1.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.81 14.54a.5.5 0 0 1 .65.27l.75 1.88a.5.5 0 0 0 .47.31h7.82a.5.5 0 0 1 0 1h-7.82a1.5 1.5 0 0 1-1.4-.94l-.74-1.87a.5.5 0 0 1 .27-.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShopingFilled);
export default ForwardRef;